import styled, { keyframes } from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

const fadeInKeyframes = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const StyledCardContentBase = styled.div`
    animation: ${fadeInKeyframes} 200ms ease-in-out;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    max-width: 100%;
`;

export const StyledCard = styled.div<{ width?: string }>`
    width: ${({ width }) => (width ? width : "100%")};
    background-color: ${colorsPalettes.carbon["0"]};
    border-radius: 6px;
    box-shadow: 0 3px 6px ${rgba(colorsPalettes.carbon["500"], 0.08)};
    display: flex;
    flex-direction: column;
    flex: 1;
    user-select: none;
    margin-top: 24px;
`;
